import { render, staticRenderFns } from "./RiderReceiptManagement.vue?vue&type=template&id=39af54a6&scoped=true"
import script from "./RiderReceiptManagement.vue?vue&type=script&lang=js"
export * from "./RiderReceiptManagement.vue?vue&type=script&lang=js"
import style0 from "./RiderReceiptManagement.vue?vue&type=style&index=0&id=39af54a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39af54a6",
  null
  
)

export default component.exports